import { render } from "./copay-block.vue?vue&type=template&id=7f92dc78&scoped=true"
import script from "./copay-block.vue?vue&type=script&lang=js"
export * from "./copay-block.vue?vue&type=script&lang=js"

import "./copay-block.vue?vue&type=style&index=0&id=7f92dc78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f92dc78"]])

export default __exports__